// // import PrintDailyReport from "./PrintDailyReports";

// // // تستقبل مصفوفة الجلسات (sessions) وخيارات اختيارية ثم تمرّرها لـ PrintDailyReport
// // export const printDailyReportUtils = async (sessions = [], options = {}) => {
// //   const printWindow = window.open("", "printWindow", "width=900,height=700");
// //   if (!printWindow) {
// //     alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
// //     return;
// //   }

// //   try {
// //     // PrintDailyReport متوقع أن يُرجع HTML جاهز للطباعة عند تمرير الجلسات
// //     const html = await PrintDailyReport(sessions, options);

// //     printWindow.document.open();
// //     printWindow.document.write(html);
// //     printWindow.document.close();
// //     printWindow.focus();

// //     const tryClose = () => {
// //       try {
// //         if (printWindow && !printWindow.closed) printWindow.close();
// //       } catch (e) {
// //         /* ignore */
// //       }
// //     };

// //     printWindow.onafterprint = tryClose;
// //     try {
// //       printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
// //     } catch (e) {
// //       /* ignore */
// //     }

// //     const fallbackTimer = setTimeout(() => {
// //       tryClose();
// //     }, 12000);

// //     const clearIfClosed = () => {
// //       if (!printWindow || printWindow.closed) {
// //         clearTimeout(fallbackTimer);
// //         try {
// //           printWindow.onafterprint = null;
// //           printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
// //         } catch (e) {}
// //       }
// //     };

// //     printWindow.print();
// //     const pollInterval = setInterval(() => {
// //       if (!printWindow || printWindow.closed) {
// //         clearInterval(pollInterval);
// //         clearIfClosed();
// //       }
// //     }, 500);
// //   } catch (err) {
// //     console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
// //     alert("فشل في تجهيز تقرير الطباعة.");
// //     try {
// //       if (!printWindow.closed) printWindow.close();
// //     } catch (e) {}
// //   }
// // };

// // ==============================
// // ✅ printDailyReportUtils (مقاس ريسيت + يمرّر options صح)
// // ==============================
// import PrintDailyReport from "./PrintDailyReports";

// // تستقبل مصفوفة الجلسات (sessions) وخيارات اختيارية ثم تمرّرها لـ PrintDailyReport
// export const printDailyReportUtils = async (sessions = [], options = {}) => {
//   const printWindow = window.open("", "printWindow", "width=900,height=700");
//   if (!printWindow) {
//     alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
//     return;
//   }

//   try {
//     // ✅ مهم جدًا: options لازم يكون الباراميتر الرابع
//     const html = await PrintDailyReport(sessions, {}, null, options);

//     printWindow.document.open();
//     printWindow.document.write(html);
//     printWindow.document.close();
//     printWindow.focus();

//     const tryClose = () => {
//       try {
//         if (printWindow && !printWindow.closed) printWindow.close();
//       } catch (e) {}
//     };

//     printWindow.onafterprint = tryClose;
//     try {
//       printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
//     } catch (e) {}

//     const fallbackTimer = setTimeout(() => {
//       tryClose();
//     }, 12000);

//     const pollInterval = setInterval(() => {
//       if (!printWindow || printWindow.closed) {
//         clearInterval(pollInterval);
//         clearTimeout(fallbackTimer);
//         try {
//           printWindow.onafterprint = null;
//           printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
//         } catch (e) {}
//       }
//     }, 500);

//     printWindow.print();
//   } catch (err) {
//     console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
//     alert("فشل في تجهيز تقرير الطباعة.");
//     try {
//       if (!printWindow.closed) printWindow.close();
//     } catch (e) {}
//   }
// };


import PrintDailyReport from "./PrintDailyReports";

// ✅ تستقبل sessions + options وتطبع على نافذة جديدة
export const printDailyReportUtils = async (sessions = [], options = {}) => {
  const printWindow = window.open("", "printWindow", "width=900,height=700");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  try {
    const resolvedOptions = {
      paperWidthMm: 72.1,
      printableWidthMm: 72.1,
      fontSize: 16,
      lineHeight: 1.3,
      ...options,
    };

    // ✅ مهم: مرّر options في مكانه الصحيح (الرابع)
    const html = await PrintDailyReport(sessions, {}, null, resolvedOptions);

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();

    const tryClose = () => {
      try {
        if (printWindow && !printWindow.closed) printWindow.close();
      } catch (e) {}
    };

    printWindow.onafterprint = tryClose;
    try {
      printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
    } catch (e) {}

    const fallbackTimer = setTimeout(() => {
      tryClose();
    }, 12000);

    const pollInterval = setInterval(() => {
      if (!printWindow || printWindow.closed) {
        clearInterval(pollInterval);
        clearTimeout(fallbackTimer);
        try {
          printWindow.onafterprint = null;
          printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
        } catch (e) {}
      }
    }, 500);

    printWindow.print();
  } catch (err) {
    console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
    alert("فشل في تجهيز تقرير الطباعة.");
    try {
      if (!printWindow.closed) printWindow.close();
    } catch (e) {}
  }
};
